import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const Checkmark = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M11.25 14.25L9 12" />
      <path d="M15 10.5L11.25 14.25" />
    </svg>
  );
};
